<div class="user-overview-container geaui-sidebar-grid">
  <app-user-info [data]="userData()" [isLoading]="isLoading()"></app-user-info>
  @if (!isLoading()) {
    <app-user-access-control
      class="access-controls"
      [allFeatureFlags]="allFeatureFlags()"
      [enabledFeatureFlags]="enabledFeatureFlags()"
      [permissions]="userPermissions()"
      [productGroups]="productGroups()"
      (isDirtyChange)="onDirtyChange($event)"
      (save)="onSave($event)">
    </app-user-access-control>
  } @else {
    <div class="skeleton-access-controls">
      <!-- Feature Flags skeleton -->
      <p-skeleton width="8rem" height="1.5rem" borderRadius="0.25rem" styleClass="mb-3" />
      <div class="skeleton-flags-card">
        @for (row of [1, 2, 3, 4, 5, 6]; track row) {
          <div class="skeleton-flag-row">
            <div class="skeleton-flag-cell">
              <p-skeleton width="9rem" height="1rem" borderRadius="0.25rem" />
              <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem" />
            </div>
            <div class="skeleton-flag-cell">
              <p-skeleton width="9rem" height="1rem" borderRadius="0.25rem" />
              <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem" />
            </div>
          </div>
        }
      </div>

      <!-- Permissions skeleton -->
      <p-skeleton width="8rem" height="1.5rem" borderRadius="0.25rem" styleClass="mt-4 mb-3" />
      <div class="skeleton-permissions">
        @for (panel of [1, 2, 3]; track panel) {
          <div class="skeleton-accordion-panel">
            <div class="skeleton-accordion-header">
              <p-skeleton width="6rem" height="1.25rem" borderRadius="0.25rem" />
              <p-skeleton width="1.5rem" height="1.5rem" borderRadius="0.25rem" />
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
